import { useState } from "react";
import { motion } from "framer-motion";
import { usePlay, Panel, Stat } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

export const DiceGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [target, setTarget] = useState(50);
  const [dir, setDir] = useState("over");
  const [roll, setRoll] = useState(null);
  const [res, setRes] = useState(null);
  const chance = dir === "over" ? 100 - target : target;
  const mult = Math.floor((97 / chance) * 10000) / 10000;

  const go = async () => {
    setRes(null);
    const d = await play("/games/dice", { bet, target, direction: dir });
    if (!d) return;
    let i = 0;
    const iv = setInterval(() => {
      setRoll(Math.random() * 100); sfx.reelTick();
      if (++i > 12) { clearInterval(iv); setRoll(d.roll); setRes(d); finish(d); }
    }, 55);
  };

  const winL = dir === "over" ? target : 0;
  const winW = dir === "over" ? 100 - target : target;
  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="dice-game">
      <Panel className="order-2 lg:order-1">
        <div><p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Mərc</p><BetControl value={bet} onChange={setBet} disabled={busy} testid="dice-bet" /></div>
        <div className="grid grid-cols-2 gap-2">
          {[["under", "Altı"], ["over", "Üstü"]].map(([v, l]) => (
            <button key={v} disabled={busy} onClick={() => setDir(v)} className={`rounded-xl py-3 font-display font-bold transition-colors ${dir === v ? "bg-[#D4AF37] text-black" : "bg-white/5 hover:bg-white/10"}`} data-testid={`dice-dir-${v}`}>{l} {target}</button>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-2">
          <Stat label="Şans" value={`${chance.toFixed(0)}%`} testid="dice-chance" />
          <Stat label="Əmsal" value={`x${mult}`} testid="dice-mult" />
          <Stat label="Qazanc" value={fmtAZN(bet * mult)} />
        </div>
        <button disabled={busy} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="dice-roll-btn">Zər at</button>
      </Panel>
      <div className="machine-frame rounded-3xl p-6 sm:p-10 order-1 lg:order-2 flex flex-col justify-center gap-10 min-h-[360px]">
        <motion.p key={res ? "r" : roll} className={`text-center font-display font-black text-7xl sm:text-8xl tracking-tighter ${res ? (res.won ? "text-emerald-400" : "text-red-500") : "text-white"}`} data-testid="dice-result">
          {roll == null ? "50.00" : roll.toFixed(2)}
        </motion.p>
        <div className="relative pt-8">
          <div className="relative h-4 rounded-full bg-red-500/70 overflow-hidden">
            <div className="absolute top-0 h-full bg-emerald-500" style={{ left: `${winL}%`, width: `${winW}%` }} />
          </div>
          {roll != null && (
            <motion.div animate={{ left: `${roll}%` }} transition={{ duration: 0.05 }} className="absolute top-0 -translate-x-1/2">
              <div className={`w-10 h-10 rounded-lg rotate-45 border-2 ${res ? (res.won ? "bg-emerald-500 border-emerald-300" : "bg-red-500 border-red-300") : "bg-white border-zinc-300"}`} />
            </motion.div>
          )}
          <input type="range" min="2" max="98" value={target} disabled={busy} onChange={(e) => setTarget(Number(e.target.value))}
            className="w-full mt-4 accent-[#D4AF37]" data-testid="dice-target-slider" />
          <div className="flex justify-between text-xs text-zinc-500"><span>0</span><span>25</span><span>50</span><span>75</span><span>100</span></div>
        </div>
      </div>
    </div>
  );
};
